/**
 * NOTE: For compatibility across platforms all calls **must** return a
 * `Promise` object!
 */

import { PlatformMessage } from '@reachmedianetwork/post-message-client-rds-api';
import { PlayerPmc } from '../PlayerPmc';

/** */
export interface VideoOutputInterface {
    /**
     * **Feature:** Disable/enable video output signal (ie. HDMI/VGA/etc.).
     *
     * The absence of a signal will cause some monitors to go into standby mode.
     *
     * @param disableOutput (default: `true`)
     * @returns current state of video output
     */
    disableVideoOutput(disableOutput?: boolean): Promise<boolean>;
}

export function supportsVideoOutput(platform: unknown): platform is VideoOutputInterface {
    if (platform instanceof PlayerPmc) {
        return platform.supportsMessage(PlatformMessage.VideoOutputSet);
    }
    return platform instanceof Object && 'disableVideoOutput' in platform;
}
